module.exports = "../../app/cells/components/handle_title_segment/show.erb";